export const DeviceModelNumberKey = 'DEVICE_MODEL_NUMBER' as const;
